import React, {Component} from 'react';
import { Group } from '@vx/group';
import { ViolinPlot, BoxPlot } from '@vx/stats';
import { LinearGradient } from '@vx/gradient';
import { scaleBand, scaleLinear } from '@vx/scale';
import { genStats } from '@vx/mock-data';
import { withTooltip, Tooltip } from '@vx/tooltip';
import { PatternLines } from '@vx/pattern';
import Typography from '@material-ui/core/Typography';
import Plot from 'react-plotly.js';
import { withStyles } from '@material-ui/core/styles';
import {font} from '../CSS/font'

var styles = {...font}

function getrandom(num , mul) {
    var value = [ ];
    for ( var i = 0; i <= num; i++ ) {
        var rand = Math.random() * mul;
        value.push(rand);
    }
    return value;
}




class customizedBoxPlot extends Component{


    constructor(props) {
        super(props);
        this.state = {
            tooltipOpen: false,
            tooltipLeft: 0,
            tooltipTop: 0,
            tooltipData: {}
        };
    }


    render(){
        var {classes} = this.props
        var data = [];
        var xData = ['Carmelo Anthony'];

        var yData = [
                getrandom(30 ,10)
            ];
        var colors = this.props.color

        console.log(this.props.xData)
        var layout = {
            yaxis: {
                autorange: true,
                showgrid: true,
                zeroline: true,
                dtick: 5,
                gridcolor: 'rgb(255, 255, 255)',
                gridwidth: 1,
                zerolinecolor: 'rgb(255, 255, 255)',
                zerolinewidth: 2
            },
            margin: {
                l: 40,
                r: 30,
                b: 80,
                t: 30
            },
            showlegend: false
        };

        for ( var i = 0; i < this.props.xData.length; i ++ ) {
            var result = {
                type: 'box',
                y: this.props.yData[i],
                name: '',
                jitter: 0.5,
                whiskerwidth: 0.2,
                fillcolor: 'cls',
                marker: {
                    size: 2
                },
                line: {
                    width: 1
                }
            };
            data.push(result);
        };

        return (
            <div style={{width:'150px', display:'inline-block'}}>
                <Typography className = {classes.font_family}>
                    {this.props.xData[0]}
                </Typography>
                <Plot
                  style={{width:'150px', display:'inline-block'}}
                  data={data}
                  config={{displayModeBar: false}}
                  layout={layout}
                />
            </div>
        );
    }          
}
export default withStyles(styles)(customizedBoxPlot)




// WEBPACK FOOTER //
// ./src/components/CSSComponent/boxChart.js